import { render, staticRenderFns } from "./TagsManagerList.vue?vue&type=template&id=a3f43c12&scoped=true&"
import script from "./TagsManagerList.vue?vue&type=script&lang=js&"
export * from "./TagsManagerList.vue?vue&type=script&lang=js&"
import style0 from "./TagsManagerList.vue?vue&type=style&index=0&id=a3f43c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f43c12",
  null
  
)

export default component.exports